import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {CustomEase} from 'gsap/CustomEase';
import {DrawSVGPlugin} from 'gsap/DrawSVGPlugin';
gsap.registerPlugin( ScrollTrigger, CustomEase, DrawSVGPlugin );
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
    },
    createAnimation: function( elements, startAnimationObj, animationFunction, start = 'top 90%' ) {
      if ( ( typeof elements === 'string' && document.querySelectorAll( elements ).length > 0 ) || ( typeof elements === 'object' && elements.length > 0 ) ) {
        gsap.set( elements, startAnimationObj );

        const triggers = ScrollTrigger.batch( elements, {
          toggleClass: 'js-animated',
          once: true,
          start: start,
          onEnter: ( triggerElements ) => {
            animationFunction( triggerElements, 'original' );
          },
        } );

        ScrollTrigger.addEventListener( 'refreshInit', () => {
          triggers.forEach( ( trigger, index ) => {
            if ( trigger.progress > 0 ) {
              animationFunction( [trigger.trigger], 'refresh' );
            }
          } );
        } );
      }
    },
    drawReverse: function( elements ) {
      $( elements ).each( function( index, element ) {
        const tl = gsap.timeline();
        tl.to( element, {duration: 2, drawSVG: '0% 100%'} );

        /* Opacity style and transitions */
        tl.to( element, {
          autoAlpha: 1, // property/value
          duration: 0.35, // duration e.g. 0.35s
        }, 0 );

        /* Fade in sibling arrow once draw is complete */
        const arrow = $( element ).siblings( '.js-draw-arrow' );
        if ( arrow.length ) {
          tl.to( arrow, {autoAlpha: 1, duration: 0.35}, '-=0.2' );
        }
      } );
    },
    draw: function( elements, trigger ) {
      $( elements ).each( function( index, element ) {
        const tl = gsap.timeline();
        tl.to( element, {duration: 2, drawSVG: '100%'} );

        /* Opacity style and transitions */
        tl.to( element, {
          autoAlpha: 1, // property/value
          duration: 0.35, // duration e.g. 0.35s
        }, 0 );

        /* Fade in sibling arrow once draw is complete */
        const arrow = $( element ).siblings( '.js-draw-arrow' );
        if ( arrow.length ) {
          tl.to( arrow, {autoAlpha: 1, duration: 0.35}, '-=0.2' );
        }
      } );
    },
    finalize: function() {
    },
    animate: function() {
      if ( !window.matchMedia( '(prefers-reduced-motion)' ).matches ) {
        $( `
        .js-fade:not(.js-ignore),
        .js-reveal:not(.js-ignore),
        .js-fade-group
        ` ).each( function() {
          gsap.registerPlugin( ScrollTrigger );
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: 'top 85%',
              scrub: 0.15,
              onRefresh: ( self ) => {
                if ( self.progress > 0 ) {
                  $( this ).addClass( 'js-animated' );
                }
              },
              onEnter: ( {progress, direction, isActive} ) => {
                if ( $( this ).hasClass( 'js-fade-group' ) ) {
                  $( this ).find( '> *' ).each( function( childKey, child ) {
                    const delay = ( childKey + 1 ) / 10;
                    child.style.setProperty( '--fade-group-delay', delay + 's' );
                  } );
                }
                $( this ).addClass( 'js-animated' );
              },
            },
          } );
        } );
        $( `
          .js-fade.fade-on-load:not(.js-ignore),
          .js-reveal.fade-on-load:not(.js-ignore),
          .js-fade-group.fade-on-load
          ` ).each( function() {
          gsap.registerPlugin( ScrollTrigger );
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: 'top 100%',
              scrub: 0.15,
              onRefresh: ( self ) => {
                if ( self.progress > 0 ) {
                  $( this ).addClass( 'js-animated' );
                }
              },
              onEnter: ( {progress, direction, isActive} ) => {
                if ( $( this ).hasClass( 'js-fade-group' ) ) {
                  $( this ).find( '> *' ).each( function( childKey, child ) {
                    const delay = ( childKey + 1 ) / 10;
                    child.style.setProperty( '--fade-group-delay', delay + 's' );
                  } );
                }
                $( this ).addClass( 'js-animated' );
              },
            },
          } );
        } );


        const drawSVGClasses = '.js-draw:not(.js-ignore)';
        const drawArrowSVGClasses = '.js-draw-arrow:not(.js-ignore)';
        if ( document.querySelectorAll( drawArrowSVGClasses ).length > 0 ) {
          gsap.set( drawArrowSVGClasses, {autoAlpha: 0} );
        }

        COMPONENT.createAnimation( drawSVGClasses, {drawSVG: '0%', autoAlpha: 0}, COMPONENT.draw );

        const drawReverseSVGClasses = '.js-draw-reverse:not(.js-ignore)';
        COMPONENT.createAnimation( drawReverseSVGClasses, {drawSVG: '100% 100%', autoAlpha: 0}, COMPONENT.drawReverse );
      }
    },
    onError: function() {
      document.querySelectorAll( '.js-fade' )?.forEach( ( el ) => {
        el.classList.remove( 'js-fade' );
      } );
    },
  };
  app.registerComponent( 'animations', COMPONENT );
} )( app );
